// Util
import { treatErrorAs } from 'api/errors';
import generateUuid from 'uuid/v4';

// Constants
import { errorLevel } from 'constants/errors';
import { resourceType } from 'constants/loading';

// finders
import {
  findFieldHealthImageryByFieldId,
  findFieldViewImageryByFieldId,
  findNonSatImageryByFieldId,
  findScoutingImageryByFieldId,
  findSoilSampleImageryByFieldId,
  findSsurgoImageryByFieldId
} from 'imagery/finders';

// selectors
import { getActiveFieldId } from 'current/selectors';

// actions
import {
  setResourceLoaded, setResourcePending
} from 'loading';

export const requestEditImageryLayers = () => {
  return (dispatch, getState) => {
    const state = getState();
    const fieldId = getActiveFieldId(state);

    return Promise.all([
      findSsurgoImageryByFieldId({ dispatch, getState, fieldId })
      .catch( treatErrorAs({ severity: errorLevel.INFO })),

      findFieldHealthImageryByFieldId({ dispatch, getState, fieldId })
      .catch( treatErrorAs({ severity: errorLevel.INFO })),

      findSoilSampleImageryByFieldId({ dispatch, getState, fieldId })
      .catch( treatErrorAs({ severity: errorLevel.INFO })),

      findNonSatImageryByFieldId({ dispatch, getState, fieldId })
      .catch( treatErrorAs({ severity: errorLevel.INFO })),

      findFieldViewImageryByFieldId({ dispatch, getState, fieldId })
      .catch( treatErrorAs({ severity: errorLevel.INFO }))
    ]);
  };
};

export const requestGenerateZoneLayers = () => {
  return (dispatch, getState) => {
    const state = getState();
    const fieldId = getActiveFieldId(state);
    const type = resourceType.SELECT_FIELD_MAP_LAYER;
    const id = generateUuid();
    return Promise.resolve()
    .then(() => {
      const pendingPromise = Promise.all([
        findScoutingImageryByFieldId({ dispatch, getState, fieldId })
      ]);

      dispatch(setResourcePending({
        type,
        id,
        promise: pendingPromise,
        exclusive: true
      }));

      return pendingPromise
      .then(() => dispatch(setResourceLoaded({ type, id })) );
    });
  };
};
